import { render } from "./ProductList.vue?vue&type=template&id=3b849ce1&scoped=true&bindings={\"goBack\":\"setup\",\"productDetail\":\"setup\",\"getSearch\":\"setup\",\"changeTab\":\"setup\",\"onLoad\":\"setup\",\"onRefresh\":\"setup\"}"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=3b849ce1&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3b849ce1"

export default script